/* eslint-disable @typescript-eslint/no-explicit-any */
import { services } from '../services';

interface AmenityResponse {
  data: {
    data: any;
  };
}

interface AmenityParams {
  [key: string]: any;
}

export const amenitiesActions = {
  getAmenities,
  addAmenity,
  updateAmenity,
  deleteAmenity,
  getAmenityById,
  getAmenitiesByIds,
};

function getAmenities(): Promise<any> {
  const response = services.get<AmenityResponse>(`/amenity/list`);
  return response.then((promise) => {
    if (promise && 'data' in promise) {
      return promise.data;
    } else {
      return Promise.reject('Error fetching amenities');
    }
  });
}

function addAmenity(params: AmenityParams): Promise<any> {
  const formData = new FormData();

  // Add image if provided
  if (params.image) {
    formData.append('image', params.image);
  }

  // Add other fields
  if (params.name) formData.append('name', params.name);
  if (params.slugText) formData.append('slugText', params.slugText);
  if (params.isActive !== undefined) formData.append('isActive', params.isActive.toString());

  const response = services.post<AmenityResponse>(`/amenity/add`, formData);
  return response.then((promise) => {
    if (promise && 'data' in promise) {
      return promise.data;
    } else {
      return Promise.reject('Error adding amenity');
    }
  });
}

function updateAmenity(id: string | number, params: AmenityParams): Promise<any> {
  const formData = new FormData();

  // Add image if provided
  if (params.image) {
    formData.append('image', params.image);
  }

  // Add other fields
  if (params.name) formData.append('name', params.name);
  if (params.slugText) formData.append('slugText', params.slugText);
  if (params.isActive !== undefined) formData.append('isActive', params.isActive.toString());

  const response = services.put<AmenityResponse>(`/amenity/update/${id}`, formData);
  return response.then((promise) => {
    if (promise && 'data' in promise) {
      return promise.data;
    } else {
      return Promise.reject('Error updating amenity');
    }
  });
}

function deleteAmenity(id: string | number): Promise<any> {
  const response = services.delete<AmenityResponse>(`/amenity/delete/${id}`);
  return response.then((promise) => {
    if (promise && 'data' in promise) {
      return promise.data;
    } else {
      return Promise.reject('Error deleting amenity');
    }
  });
}

function getAmenityById(id: string | number): Promise<any> {
  const response = services.get<AmenityResponse>(`/amenity/${id}`);
  return response.then((promise) => {
    if (promise && 'data' in promise) {
      return promise.data;
    } else {
      return Promise.reject('Error fetching amenity');
    }
  });
}

function getAmenitiesByIds(ids: string[]): Promise<any> {
  const response = services.post<AmenityResponse>(`/amenity/many`, { ids });
  return response.then((promise) => {
    if (promise && 'data' in promise) {
      return promise.data;
    } else {
      return Promise.reject('Error fetching amenities');
    }
  });
}
